import React, { useReducer, useEffect } from "react";
import Reducer from "./reducer";
import { initialState } from "./initialState";
import Html from "./html";
import Context from "./context";
import { loadData } from "./service";

const AllJobs = () => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        loadData({
            page_number: state.page_number, 
            search_value: state.search_value,
            sort_key: state.sort_key,
            sort_direction: state.sort_direction,
            dispatch: dispatch
        });
    }, [state.page_number, state.search_value, state.sort_key, state.sort_direction]); 

    return (
        <Context.Provider value={{state, dispatch}}>
            <Html/>
        </Context.Provider>
    );
}

export default AllJobs;